import { matchRoutes } from 'react-router-dom';
import { validateScreenHint } from '@coopercarga/flow-chat/protocol';

// Tela atual enviada ao Flow (`screenHint { id, label }`), derivada do menu. Só o id e o rótulo da
// tela: nunca o caminho, parâmetros, query ou dados do usuário. A tabela id → rótulo fica em
// docs/integrations/flow-chat.md, e o e2e confere que ela bate com o menu.

/** Minúsculas sem acento, só [a-z0-9] separados por hífen. */
function slug(text) {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

const menuId = (id) => id.replace(/^menu-/, '');

// id: o do item de menu sem `menu-`; sem ele (telas ocultas, como cadastro e detalhe), o do grupo
// mais o título. Rótulo: o título, com o grupo na frente quando o item é filho de um grupo.
// Dica que o pacote recusaria vira null, para o launcher nunca lançar.
function hintFor(route, group) {
  if (typeof route.title !== 'string') return null;
  const title = route.title.trim();
  const groupTitle = typeof group?.title === 'string' ? group.title.trim() : '';
  let id;
  if (typeof route.id === 'string') {
    id = menuId(route.id);
  } else {
    const prefix = typeof group?.id === 'string' ? menuId(group.id) : slug(groupTitle);
    id = [prefix, slug(title)].filter(Boolean).join('-');
  }
  const label = groupTitle && groupTitle !== title ? `${groupTitle} › ${title}` : title;
  const result = validateScreenHint({ id, label });
  return result.ok ? result.value : null;
}

/**
 * Rotas do menu com a dica de cada tela, na ordem de src/routes.js: com caminho repetido, vale a
 * primeira, como no roteador. Só `path` e `hint`: o matchRoutes trataria `children` como rotas
 * aninhadas.
 */
export function toScreenRoutes(menu) {
  const top = menu
    .filter((route) => route.path)
    .map((route) => ({ path: route.path, hint: hintFor(route) }));
  const children = menu.flatMap((group) =>
    (group.children ?? [])
      .filter((route) => route.path)
      .map((route) => ({ path: route.path, hint: hintFor(route, group) })),
  );
  return [...top, ...children];
}

/** Tela da rota atual (`{ path, hint }`), ou `undefined` fora das rotas do menu. */
export function matchScreen(screenRoutes, pathname) {
  return matchRoutes(screenRoutes, pathname)?.[0].route;
}
